export const PLATFORM_ALEXA = "alexa";
export const PLATFORM_GOOGLE_ACTUIBS = "googleActions";
export const PLATFORM_DIALOGFLOW = "dialogflow";
export const PLATFORM_VOICIFY = "voicify";
export const PLATFORM_LUIS = "luis";